import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { fetchFundsViewV2 } from '../services/backendAPI';

/**
 * Hook for fetching funds data using TanStack Query (once, no polling)
 * @returns {Object} Query result object containing data, loading and error states
 */
const useFundsQuery = () => {
  const dispatch = useDispatch();
  
  const query = useQuery({
    queryKey: ['funds'],
    queryFn: async () => {
      const response = await fetchFundsViewV2();
      // Update Redux store with the response data
      if (response && response.data) {
        dispatch({
          type: "SET_FUNDS_VIEW_V2",
          payload: response.data.values,
        });
      }
      return response.data;
    },
    // Removed polling and background refetching
    refetchOnWindowFocus: false,
    staleTime: Infinity, // Data never becomes stale
    cacheTime: Infinity, // Cache the data indefinitely
    retry: 3,
    onError: (error) => {
      console.error('Error fetching funds data:', error);
    }
  });

  return query;
};

export default useFundsQuery; 